import config from '@/config'
import AppState from '@/states/app'
import { requests } from './BaseService'


export interface ICreateSmsTemplateOptions {
  locationId: string
  name: string
  text: string
  updatedBy?: string
}

export interface ISms {
  to: string
  message: string
}

export default class SmsService {
  sms: ISms

  constructor(sms) {
    this.sms = sms
  }

  async sendTestSms() {
    try {
      await requests().post(`${config.baseUrl}/message/preview`, {
        location_id: AppState.locationId,
        user_id: AppState.user?.id,
        type: 'sms',
        message: this.sms.message,
        phone: this.sms.to,
        attachments: []
      })
    } catch (err) {
      console.error(err)
      throw err
    }
  }
}

export const SmsBuilderService = {
  createSmsTemplate: (options: ICreateSmsTemplateOptions) =>
    requests().post(
      `${config.restApiUrl}/locations/${AppState.locationId}/templates`,
      {
        type: 'sms',
        name: options.name,
        template: {
          body: options.text,
        },
      }
    ),
}
